const positiveId = (value) => Number.isFinite(Number(value)) && Number(value) > 0;
const roleName = (user) => String(user?.data?.userRoles?.roleName || "").trim().toLowerCase();

export const isMohCourseUser = (user) => String(user?.data?.userFacility?.code || "").trim().toUpperCase() === "MOH" || [
    "moh", "moh user", "moh users", "fmoh", "ministry of health", "federal ministry of health",
].includes(roleName(user));

export const canViewCourseCatalog = (user) => Boolean(user?.data) && (
    positiveId(user.data.cpdProviderId) || positiveId(user.data.accreditorId) || isMohCourseUser(user) || [
        "system admins", "system admin", "super admin", "super admins", "superadmin",
        "cpd provider", "cpd coordinator", "cpd director", "cpd leader ceo",
        "cpd accreditor", "cpd accreditors", "accreditor", "accreditors", "accredit course",
    ].includes(roleName(user))
);

export const canAccreditCourses = (user) =>
    positiveId(user?.data?.accreditorId) || isMohCourseUser(user);

export const canChooseCourseAccreditor = (user) =>
    isMohCourseUser(user) && !positiveId(user?.data?.accreditorId);
